import "./MatchKeyEventComponents.css";

import { ISoccerMatchSubstituteEvent } from "../../../../../../../types";

export const SubtituteEvent = ({
  event,
  isHomeTeamEvent,
  isAwayTeamEvent,
}: {
  event: ISoccerMatchSubstituteEvent;
  isHomeTeamEvent: boolean;
  isAwayTeamEvent: boolean;
}) => {
  return (
    <div className="match-key-event">
      <div className="home-team-match-key-event home-team-subtitute-event">
        {isHomeTeamEvent && (
          <>
            <div className="subtitute-names-stack">
              <span className="event-player-name">{event.playerOnName}</span>
              <span className="event-player-name event-player-name-off">{event.playerOffName}</span>
            </div>
            <img
              src={"/images/match-events/subtitute.svg"}
              height={18}
              width={16}
              alt={"subtitute"}
              className="subtitute-event"
            />
          </>
        )}
      </div>
      <span className="time-match-key-event">{`${event?.timeMin}'`}</span>
      <div className="away-team-match-key-event away-team-subtitute-event">
        {isAwayTeamEvent && (
          <>
            <img
              src={"/images/match-events/subtitute.svg"}
              height={18}
              width={16}
              alt={"subtitute"}
              className="subtitute-event"
            />
            <div className="subtitute-names-stack">
              <span className="event-player-name">{event.playerOnName}</span>
              <span className="event-player-name event-player-name-off">{event.playerOffName}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
